import { render, staticRenderFns } from "./KeyboardEvents.vue?vue&type=template&id=59dce4ef&"
import script from "./KeyboardEvents.vue?vue&type=script&lang=js&"
export * from "./KeyboardEvents.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardEvents.vue?vue&type=style&index=0&id=59dce4ef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports